// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const siren: CountryValidator<"FR"> = createValidator(
  "fr.siren",
  76,
);

export default siren;
export const compact = siren.compact;
export const format = siren.format;
export const validate = siren.validate;
export const generate = (): string =>
  siren.generate?.() ??
  (() => {
    throw new Error(
      "Validator fr.siren cannot generate values",
    );
  })();
